import type { UserRole } from "@/types";

/** Page d'accueil de chaque rôle, une fois connecté. */
export function roleDashboardPath(role: UserRole): string {
  switch (role) {
    case "admin":
      return "/admin/dashboard";
    case "teacher":
      return "/teacher/dashboard";
    case "family":
      return "/parent/dashboard";
    case "student":
      return "/student/dashboard";
    default:
      return "/login";
  }
}
